module.exports = __webpack_public_path__ + "static/media/bf.9a958401.svg";